import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
} from "src/components/Default/LekUI/Accordion";
import DefaultArticle from "src/components/NewComponents/Article";

import { useFontSize } from "../../../../../hooks/useFontSize";

function Article({ article }) {
	const { fontSizeClass } = useFontSize();
	const [openedAccordions, setOpenedAccordions] = useState(
		article.paragraphs.map((_a, id) => id),
	);

	return (
		<Accordion>
			<AccordionSummary expandIcon={<ExpandMoreIcon />}>
				<span className={fontSizeClass}>{article.title}</span>
			</AccordionSummary>
			<AccordionDetails>
				<DefaultArticle
					paragraphClassName="exam-article--paragraph"
					openedAccordions={openedAccordions}
					setOpenedAccordions={setOpenedAccordions}
					sections={article.paragraphs}
					articleId={article.id}
					deprecatedArticleId={article.articleId}
					notesMode
					updateSectionNote={() => null}
				/>
			</AccordionDetails>
		</Accordion>
	);
}

export default Article;
